import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateTrackStatus } from '../../redux/slice/statusSlice';
import dynamicSocketUrl from '../../config/socketUrl';
import { toast } from 'react-toastify';

export const useTrackStatus = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const eventSource = new EventSource(`${dynamicSocketUrl()}/bbgapi/sse`, {
      withCredentials: true,
    });

    const handleStatusUpdate = (event) => {
      try {
        const data = JSON.parse(event.data);
        const { order_id, track_status } = data;
        
        if (!order_id || !track_status) {
          // console.warn('Invalid status update data:', data);
          return;
        }

        dispatch(updateTrackStatus({ order_id, track_status }));
        // console.log("Status update received:", { order_id, track_status });
        
        toast.success(`Order status updated to: ${track_status}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } catch (error) {
        // console.error('Error processing SSE message:', error);
      }
    };

    eventSource.addEventListener('trackStatusUpdated', handleStatusUpdate);

    eventSource.onerror = (error) => {
      // console.error('SSE connection error:', error);
      // Implement reconnection logic if needed
    };

    return () => {
      eventSource.removeEventListener('trackStatusUpdated', handleStatusUpdate);
      eventSource.close();
    };
  }, [dispatch]);
};